import React from 'react';
import { useIntl } from 'react-intl';
import ErrorLabel from './ErrorLabel';
import DialogHeaderWrapper from '../dialogs/DialogHeaderWrapper';

const ErrorHeader = ({
  error,
  icon,
  loading,
  onDismiss,
  title,
  warning,
}) => {
  const intl = useIntl();
  return (
    <DialogHeaderWrapper title={title || intl.formatMessage({ id: 'error.title' })} icon={icon} loading={loading}>
      {error && (<ErrorLabel error={error} warning={warning} onDismiss={onDismiss} />)}
    </DialogHeaderWrapper>
  );
};

export default ErrorHeader;
